import { Link, isRouteErrorResponse, useRouteError } from 'react-router';
import { PageShell } from '../components/PageShell';

export function NotFoundRoute() {
  return (
    <PageShell eyebrow="404" title="Nothing here">
      <div className="glass panel stack" style={{ maxWidth: 480 }}>
        <p className="hint">That page has faded out. The mandala is still <Link to="/">here</Link>.</p>
      </div>
    </PageShell>
  );
}

export function RouteError() {
  const err = useRouteError();
  const title = isRouteErrorResponse(err) ? `${err.status} ${err.statusText}` : 'Something went wrong';
  const detail = isRouteErrorResponse(err) ? (typeof err.data === 'string' ? err.data : '') : err instanceof Error ? err.message : '';
  return (
    <PageShell eyebrow="Error" title={title}>
      <div className="glass panel stack" style={{ maxWidth: 560 }}>
        {detail && <pre style={{ whiteSpace: 'pre-wrap', fontSize: 12.5, color: 'var(--fg-dim)' }}>{detail}</pre>}
        <div className="row"><Link to="/" className="btn btn--primary">Back to the mandala</Link><button type="button" className="btn" onClick={() => location.reload()}>Reload</button></div>
      </div>
    </PageShell>
  );
}
